import { render, staticRenderFns } from "./FaturamentoClienteTempo.vue?vue&type=template&id=7b12f507&scoped=true&"
import script from "./FaturamentoClienteTempo.vue?vue&type=script&lang=js&"
export * from "./FaturamentoClienteTempo.vue?vue&type=script&lang=js&"
import style0 from "./FaturamentoClienteTempo.vue?vue&type=style&index=0&id=7b12f507&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b12f507",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
